import React, { Fragment, useEffect, useState } from 'react'
import { Map, GoogleApiWrapper, Marker, Polygon } from 'google-maps-react'
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete'
import './style.css'
import { Grid } from '@material-ui/core'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { GLOBAL_CONFIG } from '../../../../config/Config'

const Maps = ({
  positions,
  name,
  className,
  onDragend,
  draggable,
  zoom,
  polygones,
  resete,
}) => {
  const [places, setplaces] = useState([])
  const [zoomSearch, setzoomSearch] = useState(null)
  const [searchPosition, setSearchPosition] = useState(null)
  const {
    value,
    suggestions: { data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete()
  const polygoneFinally = []
  if (polygones) {
    polygones.features.forEach((element) => {
      const finallys = {}
      const temp = []
      for (const i in element.geometry.coordinates[0]) {
        temp.push({
          lat: element.geometry.coordinates[0][i][1],
          lng: element.geometry.coordinates[0][i][0],
        })
      }
      finallys.polygone = temp
      polygoneFinally.push(finallys)
    })
  }

  useEffect(() => {
    if (resete) {
      setplaces([])
      setValue('')
      setSearchPosition(null)
      setzoomSearch(null)
    }
  }, [resete, setValue])

  useEffect(() => {
    const temp = []
    data.forEach((suggestion) => {
      const { description } = suggestion
      temp.push({
        label: description,
        value: description,
      })
    })
    setplaces(temp)
  }, [data])

  const onChange = async (e) => {
    setValue(e.target.value)
  }

  const onSelect = (description) => {
    setValue(description.target.value)
    clearSuggestions()
    getGeocode({ address: description.target.value })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        setSearchPosition({ lat, lng })
        setzoomSearch(15.5)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const style = {
    // width: '93%',
    width: 710,
    height: '50%',
    marginTop: '2%',

    // marginRight: '2%',
  }

  return (
    <Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <div
            style={{
              width: '100%',
            }}
          >
            <Autocomplete
              id="free-solo-demo"
              freeSolo
              options={places.map((option) => option.label)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  // Prevent's default 'Enter' behavior.
                  event.defaultMuiPrevented = true
                  event.preventDefault()
                  // your handler code
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoFocus
                  style={{ width: '102%' }}
                  label="Buscar Lugar"
                  onChange={onChange}
                  value={value}
                  onKeyDown={(ev) => {
                    if (ev.key === 'Enter') {
                      // Do code here
                      ev.preventDefault()
                      ev.defaultMuiPrevented = true
                    }
                  }}
                />
              )}
              onSelect={onSelect}
            />
            {/* <AutoComplete
              dropdownClassName="certain-category-search-dropdown"
              dropdownMatchSelectWidth={500}
              style={{
                width: 500,
              }}
              placeholder="Buscar lugar"
              onChange={onChange}
              onSelect={onSelect}
              options={options}
              value={value}
            /> */}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Map
            style={style}
            google={window.google}
            zoom={zoomSearch != null ? zoomSearch : zoom}
            className={className}
            initialCenter={searchPosition != null ? searchPosition : positions}
            center={searchPosition != null ? searchPosition : positions}
          >
            <Marker
              onDragend={onDragend}
              draggable={draggable}
              position={searchPosition != null ? searchPosition : positions}
              name={name}
            />

            {polygones
              ? polygoneFinally.map((polygone, i) => (
                  <Polygon
                    key={i}
                    paths={polygone.polygone}
                    strokeColor="#0000FF"
                    strokeOpacity={0.8}
                    strokeWeight={2}
                    fillColor="#0000FF"
                    fillOpacity={0.35}
                  />
                ))
              : null}
          </Map>
        </Grid>
      </Grid>
    </Fragment>
  )
}

const api = GLOBAL_CONFIG.googleMapsApiKey

export default GoogleApiWrapper({
  apiKey: api,
  LoadingContainer: false,
})(Maps)
